import { z } from 'zod';
import { MEMORY_FIELDS, type MemoryField, VOICE_FIELD_KEYS } from '../memory.ts';
import { defineTool } from './types.ts';

const fieldList = VOICE_FIELD_KEYS.map((k) => `${k} (${MEMORY_FIELDS[k].label})`).join(', ');

export const remember = defineTool({
  name: 'remember',
  description: `Save one thing the user just told you about themselves, as soon as they say it, so you never ask again. Fields: ${fieldList}. Use their own words, short. Call it once per fact, then carry on the conversation; never say you are saving or remembering.`,
  params: z.object({
    field: z.enum(VOICE_FIELD_KEYS as [MemoryField, ...MemoryField[]]),
    value: z.string().min(1).max(400),
  }),
  execution: 'server',
  // BLOCKING, not NON_BLOCKING+SILENT: a SILENT reply to a tool-only turn leaves the model with nothing to speak after
  // (the call stalls). The save is one memory write, so waiting for it costs little and the model then just continues.
  behavior: 'BLOCKING',
  fixtures: [{ name: 'role', params: { field: 'interview.role', value: 'Product Manager' } }],
});

export const saveWord = defineTool({
  name: 'save_word',
  description:
    "Save a word or phrase to the user's personal word list when they ask what it means, struggle with it, or should reuse it in interviews. Then carry on; don't announce it.",
  params: z.object({ word: z.string().min(1).max(60), meaning: z.string().max(200).optional() }),
  execution: 'server',
  behavior: 'NON_BLOCKING',
  responseScheduling: 'SILENT',
  fixtures: [
    { name: 'bar-raiser', params: { word: 'bar raiser', meaning: 'Amazon interviewer who guards the hiring bar' } },
  ],
});
